import { formatDecimal } from '@/lib/format';
export function formatBytes(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    const units = ['KB', 'MB', 'GB'];
    let value = bytes / 1024;
    let unitIdx = 0;
    while (value >= 1024 && unitIdx < units.length - 1) {
        value /= 1024;
        unitIdx++;
    }
    return `${value < 10 ? formatDecimal(value, 1) : Math.round(value)} ${units[unitIdx]}`;
}
export function kindLabel(kind) {
    switch (kind) {
        case 'pdf':
            return 'PDF';
        case 'image':
            return 'Image';
        case 'video':
            return 'Video';
        default:
            return 'File';
    }
}
